let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aLH2u")).then(() => parcelRequire('kMgpE'));